import React from 'react';
import { Link } from 'react-router-dom';
import './SharedPages.css';

function NotFoundPage() {
  return (
    <div className="shared-page-wrapper" style={{ textAlign: 'center', paddingTop: '160px', paddingBottom: '120px' }}>
      <h1 style={{ fontSize: '8rem', fontWeight: 900, margin: 0, color: 'var(--primary)', lineHeight: 1 }}>404</h1>
      <h2 style={{ fontSize: '2rem', fontWeight: 800, margin: '16px 0', color: 'var(--text-main)' }}>
        Page introuvable
      </h2>
      <p style={{ fontSize: '1.1rem', color: 'var(--text-muted)', marginBottom: '40px', maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
        Cette page n'existe pas ou a été déplacée. Pas de panique, retourne à l'accueil !
      </p>
      <Link to="/" className="btn-brutal primary" style={{ textDecoration: 'none' }}>
        Retour à l'accueil
      </Link>
    </div>
  );
}

export default NotFoundPage;
